import { post, get, put, patch, deleteRequest, downloadFile } from 'utils/api';

export const addCpo = (data) => {
  return post(`/ocpi_credential`, data);
};

export const getCpoData = (data) => {
  return get(`/ocpi_credential/${data}`);
};

export const fetchCpoData = (data) => {
  return get(`/ocpi_credential`, data);
};

export const updateCpo = (item) => {
  const ocpiId = item.id;
  delete item['id'];
  return patch(`/ocpi_credential/${ocpiId}`, item);
};

export const removeCpo = (id) => {
  return deleteRequest(`/ocpi_credential/${id}`);
};

// OCPI Admin operation

export const handshake = (data) => {
  return post(`/ocpi_credential/handshake/${data}`);
};

export const getEndpointByToken = (data) => {
  return get(`/ocpi_client_endpoint/${data}`);
};

export const pullLucations = (data) => {
  return post(`/ocpi/syncLocations/${data}`);
};

export const pullTariffs = (data) => {
  return post(`/ocpi/syncTariffs/${data}`);
};

export const pullSession = (data) => {
  const { id, dateFrom, dateTo } = data;
  const item = { dateFrom, dateTo };
  return post(`/ocpi/syncSessions/${id}`, item);
};

export const pullCdrs = (data) => {
  const { id, dateFrom, dateTo } = data;
  const item = { dateFrom, dateTo };
  return post(`/ocpi/syncCdrs/${id}`, item);
};

export const pullSettlement = (data) => {
  const { id, dateFrom, dateTo } = data;
  const item = { dateFrom, dateTo };
  return post(`/ocpi/syncSettlement/${id}`, item);
};

export const token = (data) => {
  return post(`/ocpi_token/syncTokens/${data}`);
};

// OCPI Limit Location

export const getLocations = (data) => {
  const id = data.id;
  delete data['id'];
  const page = data.page ? data.page : 1;
  delete data['page'];
  const sortBy = data.sortBy ? `&sortBy=${encodeURIComponent(data.sortBy)}` : '';
  delete data['sortBy'];
  const search = data.search ? `&search=${encodeURIComponent(data.search)}` : '';
  delete data['search'];
  const requestAll = data.request_all ? `&request_all=${data.request_all}` : '';
  delete data['request_all'];
  return post(`/ocpi_credential/${id}/locations?page=${parseInt(page)}${sortBy}${search}${requestAll}`, data);
};

export const updateLocation = (item) => {
  const ocpiId = item.id;
  delete item['id'];
  return patch(`/ocpi_credential/${ocpiId}`, item);
};

export const removeLocation = (data) => {
  const id = data.id;
  delete data['id'];
  return put(`/ocpi_credential/${id}/remove-locations`, data);
};


//EMSP Faulty Session Feature
export const emspFaultySession = (data) => {
  if (data.excel) {
    delete data['page'];
    delete data['limit'];
    return downloadFile('/report/emspFaultyBookings', data);
  }
  const page = data.page || 1;
  const limit = data.limit || 10;
  delete data['page'];
  delete data['limit'];
  return post(`/report/emspFaultyBookings?page=${parseInt(page)}&limit=${parseInt(limit)}`, data);
};


export const downloadEmspFaultySession = (data) => {
  return downloadFile('/report/emspFaultyBookings', data);
};
export const pullEmspCdr = (data) => {
  return post('/pull-cdr', data);
};

// CDB-1597 — outbound T+X settlement to CPO partners

export const fetchCpoSettlementBatches = (data) => {
  return get(`/cpo-settlement/batches`, data);
};

export const getCpoSettlementBatch = (data) => {
  const { batchId, ...params } = data;
  return get(`/cpo-settlement/batches/${batchId}`, params);
};

export const approveCpoSettlementBatch = (batchId) => {
  return post(`/cpo-settlement/batches/${batchId}/approve`, {});
};

export const rejectCpoSettlementBatch = (data) => {
  return post(`/cpo-settlement/batches/${data.batchId}/reject`, { reason: data.reason });
};

export const payCpoSettlementBatch = (batchId) => {
  return post(`/cpo-settlement/batches/${batchId}/pay`, {});
};

// Re-checks one in-flight payout with the provider. Distinct from the scheduled
// reconcile, which sweeps by age and cannot be aimed at a single settlement.
export const refreshCpoSettlementBatch = (batchId) => {
  return post(`/cpo-settlement/batches/${batchId}/refresh`, {});
};

export const runCpoSettlementCycle = (data) => {
  return post(`/cpo-settlement/run`, data || {});
};

export const partnerManagement = {
  addCpo,
  getCpoData,
  fetchCpoData,
  updateCpo,
  removeCpo,
  handshake,
  getEndpointByToken,
  pullLucations,
  pullTariffs,
  pullSession,
  pullCdrs,
  pullSettlement,
  token,
  getLocations,
  updateLocation,
  removeLocation,
  emspFaultySession,
  downloadEmspFaultySession,
  // CDB-1597
  fetchCpoSettlementBatches,
  getCpoSettlementBatch,
  approveCpoSettlementBatch,
  rejectCpoSettlementBatch,
  payCpoSettlementBatch,
  runCpoSettlementCycle,
};
